import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'formatTransducerType',
  standalone: true
})
export class FormatTransducerTypePipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(value: string): string {
    if (!value) return value;
    
    let translatedValue = value;
    
    if (value.includes('Geophone')) {
      translatedValue = value.replace('Geophone', this.translate.instant('RECORD.GEOPHONE') + ' ');
      translatedValue = translatedValue.replace('HzFn', ' Hz');
    }

    if (value.includes('Microphone')) { 
      translatedValue = value.replace('Microphone', this.translate.instant('RECORD.MICROPHONE') + ' ');
      translatedValue = translatedValue.replace('Hz', ' Hz');
      translatedValue = translatedValue.replace('Linear', '');
    }

    return translatedValue.trim();
  }
}
